// Angular Import
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// project import
import { AdminComponent } from './theme/layout/admin/admin.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { AuthGuard } from './core/services/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        // loadComponent: () =>
        //   import('./core/components/dashboard/dash-analytics.component'),
        loadComponent: () =>
          import('./core/components/dashboard/dashboard.component').then((m)=>m.DashboardComponent),
        data: { module: 'Dashboard' },
      },
      {
        path: 'component',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/components/ui-element/ui-basic.module').then(
            (m) => m.UiBasicModule
          ),
      },
      {
        path: 'setting',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/components/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'master',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/components/master/master.module').then(
            (m) => m.MasterModule
          ),
      },
      {
        path: 'mapping',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/components/mapping/mapping.module').then(
            (m) => m.MappingModule
          ),
      },
      {
        path: 'purchase',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./core/components/purchase/purchase.module').then(
            (m) => m.PurchaseModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./core/components/report/report.module').then(
            (m) => m.ReportModule
          ),
      },
      {
        path: 'pos-main',
        loadChildren: () =>
          import('./core/components/pos/pos.module').then(
            (m) => m.PosModule
          ),
      },
    ],
  },
  {
    path: '',
    component: GuestComponent,
    children: [
      {
        path: 'auth/forgot-password',
        loadComponent: () =>
          import(
            './core/components/authentication/forgot-password/forgot-password.component'
          ),
      },
      {
        path: 'auth/signin',
        loadComponent: () =>
          import('./core/components/authentication/sign-in/sign-in.component'),
      },
      {
        path: 'auth/error',
        loadComponent: () =>
          import('./core/components/authentication/error/error.component').then(
            (m) => m.ErrorComponent
          ),
      },
      {
        path: 'auth/reset-password/:id',
        loadComponent: () =>
          import(
            './core/components/authentication/reset-password/reset-password.component'
          ),
      },
      {
        path: 'pos',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./core/components/pos/pos.component').then(
            (m) => m.PosComponent
          ),
        data: { module: 'POS' },
      },
      {
        path: 'auth/screen',
        //canActivate: [AuthGuard],
        loadComponent: () =>
        import('./core/components/authentication/intermitted-screen/intermitted-screen.component').then((m)=>m.IntermittedScreenComponent),
        //data: { module: 'POS' },
      },
      { path: '**', redirectTo: 'auth/error', pathMatch: 'full' }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
